<template>
  <div :class="['data-picker-time', showAnyTime ?  'hideLabel' : '']">
     <commonInputDate 
      popper-class="commonNewDataPicker"
      :clearable="clearable" 
      @blur="blur"
      @change="change"
      @focus="focus"
      v-model="date" 
      :picker-options="pickerOptions"
      :default-time="['00:00:00','23:59:59']" 
      type="daterange"
      :label='label'></commonInputDate>
      <div class="anyTime" v-if="showAnyTime">{{this.placeHolder}}</div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'commonNewDataPicker',
  data(vm) {
    return {
      propsClass: '',
      status: false,
      date: [],
      isfocus: false,
      node: null,
      pickerOptions: {
          shortcuts: [{
            text: 'Last 7 Days',
            onClick(picker) {
              vm.$emit('ShortcutsClick', 'Last7Days')
              picker.$emit('pick', vm.getTime(7, 'days'));
            }
          }, 
          {
            text: 'Last 15 Days',
            onClick(picker) {
              vm.$emit('ShortcutsClick', 'Last15Days')
              picker.$emit('pick', vm.getTime(15, 'days'));
            }
          }, 
          {
            text: 'Last 30 Days',
            onClick(picker) {
              vm.$emit('ShortcutsClick', 'Last30Days')
              picker.$emit('pick', vm.getTime(30, 'days'));
            }
          },
          {
            text: 'Last 3 Months',
            onClick(picker) {
              vm.$emit('ShortcutsClick', 'Last3Month')
              picker.$emit('pick', vm.getTime(3, 'months'));
            }
          },
          {
            text: 'Last 12 Months',
            onClick(picker) {
              vm.$emit('ShortcutsClick', 'Last2Month')
              picker.$emit('pick', vm.getTime(12, 'months'));
            }
          },
          {
            text: 'Any Date',
            onClick(picker) {
              vm.$emit('ShortcutsClick', 'AnyDate')
              picker.$emit('pick', [])
            }
          }
          ]
        },
    }
  },
  created() {
  },
  watch: {
    clearable: {
      handler(val) {
        if (val === false) {
          this.pickerOptions.shortcuts.splice(5, 1)
        }
      },
      deep: true,
      immediate: true
    },
    date: {
      handler(val) {
        console.log(val, 'valu')
        this.$emit('changeValue', val || [])
      },
      deep: true,
      immediate: true
    },
    value: {
        handler(val) {
          this.date = val
        },
        deep: true,
        immediate: true
    }
  },
  model: {
    prop: 'value',
    event: 'changeValue'
  },
  props: {
    value: {
      type: [Array, null],
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Date'
    },
    placeHolder: {
      type: String,
      default: 'Any Date'
    },
    description: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    showAnyTime() {
      return (!this.date || (this.date && !this.date.length)) && !this.isfocus
    }
  },
  methods: {
    focus(...res) {
      this.isfocus = true
      this.$emit('focus', res)
    },
    blur(...res) {
      this.isfocus = false
      this.$emit('blur', res)
    },
    change(...res) {
      this.$emit('change', res)
    },
    getTime(days, time) {
      let start = moment().subtract(days, time).format('YYYY-MM-DD 00:00:00')
      let end = moment().format('YYYY-MM-DD 23:59:59')
      return [Number(moment(start).format('x')), Number(moment(end).format('x'))]
    }
  }
}
</script>
<style lang="scss">
  .data-picker-time{
    position: relative;
    .anyTime{
      position: absolute;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 13px;
      line-height: 20px;
      color: #000000;
      top: 8px;
      pointer-events: none;
      left: 12px;
    }
    &.hideLabel{
      .label-input2__label{
        display: none;
      }
    }
  }
  .commonNewDataPicker{
    &.el-picker-panel{
      width: 694px !important;
    }
    .el-picker-panel__body{
      width: 544px;
      margin-left: 150px !important;

      .el-date-range-picker__content.is-left{
        border: 0 none;
      }
    }


    .el-picker-panel__sidebar{
      padding: 8px;
      width: 150px;
      .el-picker-panel__shortcut{
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        color: #000;
        width: 100%;
        padding: 10px;
        &:hover{
          background: #F5F7FA;
          border-radius: 4px;
        }
      }
    }
  }
</style>
